module.exports = __webpack_public_path__ + "static/media/other_details.419497c8.svg";